const cf7_email_confirm = (callback) => {
   if (document.readyState != "loading") callback();
   else document.addEventListener("DOMContentLoaded", callback);
};

cf7_email_confirm(() => {
   const forms = document.querySelectorAll('.wpcf7 form');

   forms.forEach(function (form) {
      const email = form.querySelector('input[name="user_email"]');
      const confirmEmail = form.querySelector('input[name="user_confirm_email"]');

      if (!email || !confirmEmail) return;

      const fieldWrapper = confirmEmail.closest('.data-form-field');
      if (!fieldWrapper) return;

      confirmEmail.addEventListener('blur', function () {
         const existingError = form.querySelector('.email-error-message');
         if (existingError) {
            existingError.remove();
            confirmEmail.classList.remove('wpcf7-not-valid');
         }

         if (email.value !== confirmEmail.value) {
            const error = document.createElement('span');
            error.className = 'email-error-message';
            error.textContent = 'Email doesn\'t match';

            confirmEmail.classList.add('wpcf7-not-valid');
            fieldWrapper.appendChild(error);
         }
      });

      confirmEmail.addEventListener('input', function () {
         const existingError = form.querySelector('.email-error-message');
         if (existingError && email.value === confirmEmail.value) {
            existingError.remove();
            confirmEmail.classList.remove('wpcf7-not-valid');
         }
      });


      form.addEventListener('submit', function (event) {

         if (email && confirmEmail && email.value !== confirmEmail.value) {
            event.preventDefault(); // Stop submitting
            event.stopImmediatePropagation(); // Abort other CF7 handlers
            form.classList.add('invalid');
            form.classList.remove('init');

            // Add standard error output
            const responseOutput = form.querySelector('.wpcf7-response-output');
            if (responseOutput) {
               responseOutput.innerText = 'One or more fields have an error. Please check and try again.';
               responseOutput.classList.remove('wpcf7-display-none');
               responseOutput.setAttribute('aria-hidden', 'false');
            }

            // Updating the status of the form
            form.setAttribute('data-status', 'invalid');
         }
      }, true);
   });
});
